import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Flex, Box } from 'grid-styled';

import { LabelInput } from './LabelInput';
import { Label } from '../styledSystem/Text';
import { BoxTemplate } from '../styledSystem/Box';

import Background from '../assets/alert-circle.png';

class StreamNameModal extends Component {
    componentDidMount() {
        const { model } = this.props;

        let validationVariable = model.validateModelByModal('name');

        let validationObject = {};

        if (validationVariable.length > 0) {
            for (let i = 0; i < validationVariable.length; i++) {
                validationObject[validationVariable[i]] = model.validate(
                    validationVariable[i]
                );
            }

            this.props.updateState({
                formErrors: validationObject,
                formValid: false
            });
        } else {
            this.props.updateState({
                formValid: true
            });
        }
    }

    render() {
        const { model, updateState, statevariable } = this.props;

        return (
            <Box>
                <Flex>
                    <Box w={2 / 3}>
                        <LabelInput
                            label="Stream Name"
                            model={model}
                            name="streamname"
                            statevariable={statevariable}
                            updateState={updateState}
                            errormask={statevariable.formErrors.streamname}
                            background={Background}
                        />
                    </Box>
                    <BoxTemplate
                        textalign="left"
                        mr={'15px'}
                        ml={'15px'}
                        w={1 / 3}
                    >
                        <Label textStyle="labelSmall">
                            <b>Stream Name</b>
                            <br />
                            Configure a name for your stream. This name is only
                            used here in the setup and has no influence on the
                            streaming functionality
                        </Label>
                    </BoxTemplate>
                </Flex>
            </Box>
        );
    }
}

export default inject('model')(observer(StreamNameModal));



// WEBPACK FOOTER //
// ./src/form/StreamNameModal.js